package com.patronat.top.features.venues.domain.usecase.command

data class ReassignVenueModeratorCommand(
    val venueId: String,
    val moderatorId: String
)
